export const UPDATE_CURRENT_USER = 'updateCurrentUser';
export const REMOVE_CURRENT_USER = 'removeCurrentuser';